(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["hhl-quote-form"] && !Shopify.designMode) return;
  try {
    class HhlQuoteForm extends HTMLElement {
    // Shopify product titles of the quote products (template product.quote) -> form values.
    static SERVICES = Object.freeze({
      '1-Minute Custom Video': { service: 'Custom video', length: '1 minute' },
      '3-5 Minute Custom Video': { service: 'Custom video', length: '3-5 minutes' },
      '7-10 Minute Custom Video': { service: 'Custom video', length: '7-10 minutes' },
      'Custom Website Build': { service: 'Custom website build' },
      'Custom Application': { service: 'Custom application' },
      'Custom API & Integration': { service: 'Custom API & integration' },
      'Custom Automation': { service: 'Custom automation' },
      'Custom 3D Design': { service: 'Custom 3D design' },
    });

    connectedCallback() {
      this.service = this.querySelector('[data-hhl-service]');
      this.groups = this.querySelectorAll('[data-hhl-group]');
      if (!this.service) return;

      // Required only once JS can hide the group that does not apply.
      this.querySelectorAll('[data-required]').forEach((el) => {
        el.required = true;
      });

      // Checkbox groups that need at least one box ticked (no native HTML equivalent).
      this.checkGroups = this.querySelectorAll('[data-hhl-check-required]');
      this.checkGroups.forEach((group) => {
        group.addEventListener('change', () => this.validateChecks());
      });

      this.prefill();
      this.update();
      this.service.addEventListener('change', () => this.update());

      const form = this.querySelector('form');
      if (form) {
        form.addEventListener('submit', () => {
          try {
            sessionStorage.setItem('hhl-quote-kind', this.currentGroup() || 'dev');
          } catch (e) {}
        });
      }
      this.showSuccessVariant();
    }

    currentGroup() {
      const opt = this.service.selectedOptions[0];
      return opt ? opt.dataset.group || '' : '';
    }

    update() {
      const group = this.currentGroup();
      this.groups.forEach((fs) => {
        const active = fs.dataset.hhlGroup === group;
        fs.hidden = !active;
        fs.disabled = !active;
      });
      this.validateChecks();
    }

    validateChecks() {
      this.checkGroups.forEach((group) => {
        const boxes = group.querySelectorAll('input[type="checkbox"]');
        if (!boxes.length) return;
        const ticked = Array.prototype.some.call(boxes, (box) => box.checked);
        boxes[0].setCustomValidity(ticked ? '' : 'Pick at least one.');
      });
    }

    prefill() {
      let requested = '';
      try {
        requested = new URLSearchParams(window.location.search).get('service') || '';
      } catch (e) {
        return;
      }
      // Only exact titles of the quote products are honoured; anything else is ignored.
      if (!Object.prototype.hasOwnProperty.call(HhlQuoteForm.SERVICES, requested)) return;
      const known = HhlQuoteForm.SERVICES[requested];

      const source = this.querySelector('[data-hhl-source]');
      if (source) source.value = requested;
      this.service.value = known.service;

      const length = this.querySelector('[data-hhl-length]');
      if (length && known.length) length.value = known.length;
    }

    showSuccessVariant() {
      const variants = this.querySelectorAll('[data-hhl-success]');
      if (!variants.length) return;
      let kind = 'dev';
      try {
        kind = sessionStorage.getItem('hhl-quote-kind') || 'dev';
        sessionStorage.removeItem('hhl-quote-kind');
      } catch (e) {}
      variants.forEach((el) => {
        el.hidden = el.dataset.hhlSuccess !== kind;
      });
    }
  }

  if (!customElements.get('hhl-quote-form')) {
    customElements.define('hhl-quote-form', HhlQuoteForm);
  }
  } catch(e) { console.error(e); }
})();

})();
